
import { Component, Prop, Vue } from "vue-property-decorator";
import { NewResultX } from "@/lib/model/exam/result";
import { TacPsycResult } from "@/lib/model/exam/tac-mind";

enum LevelClass {
  "safe",
  "warning",
  "danger",
  "primary"
}

@Component
export default class Mandarin extends Vue {
  @Prop({ type: TacPsycResult, default: new TacPsycResult() })
  mindRes!: TacPsycResult;
  @Prop({ type: Boolean, default: false }) isH5!: boolean;

  get LevelClass() {
    return LevelClass;
  }

  get obvervationalEvaluateLevel() {
    if (this.isH5) return LevelClass.primary;

    return this.mindRes.obvervationalEvaluateShowList.length
      ? LevelClass.danger
      : LevelClass.safe;
  }
}
